import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Layout state store - manages sidebar collapse, etc.
 * Sprint 31.7: Created to match mockup-1 sidebar collapse behavior
 */
interface LayoutState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useLayoutStore = create<LayoutState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
    }),
    {
      name: 'vortex-layout',
    }
  )
);
